import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import ProductContext from '@/product/context/product/productContext'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Loaders from '../../../../product/components/molecules/Loaders'
import DynamicDropdown from './DynamicDropdown'
import { socket, reInitializeSocket } from '@/product/common/socket'
import CustomDialog from '@/product/components/organisms/Dialog'
import { Button, Step, StepLabel, Stepper } from '@mui/material'
import LinearProgress from '@mui/material/LinearProgress'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import ProductCommonContext from '@/product/context/common/commonContext'

const BulkListing = (props) => {
    const { bulkProjectAction, responseStatus: responseStatusProduct } =
        useContext(ProductContext)
    const { getMainDashboardData } = useContext(ProductCommonContext)
    const [isLoading, setIsLoading] = useState(false)

    const [progress, setProgress] = useState(0)
    const [activeTab, setActiveTab] = useState(0)

    const [bulkUploadPopup, setBulkUploadPopup] = useState(false)
    const [socketMessage, setSocketMessage] = useState({
        status: '',
    })

    const changeSetBulkUploadPopup = () => {
        setBulkUploadPopup(!bulkUploadPopup)
    }

    const dynamicContext = useContext(DynamicContext)

    const { project_dynamicfields } = dynamicContext

    const [fieldValue, setFieldValue] = useState([])

    const { getAllSampleDownload } = useContext(ReportContext)

    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        uploadFiles: Yup.array().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            auctiontype: 'live',
            uploadFiles: [],
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            // setIsLoading(true)
            let value = values
            value.ignoreFields = props.ignoreFields
            value.preFillFields = props.preFillFields ? props.preFillFields : {}
            value.fillIDFields = props.fillIDFields ? props.fillIDFields : []
            value.quick = props?.quick || false
            bulkProjectAction(value)
        },
    })
    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    }, [])
    const formSubmit = (data) => {
        formik.values.market_status = data
        formik.submitForm().then(setIsLoading(false)).catch(setIsLoading(false))
    }

    const productListing = [
        {
            type: 'uploadDropZone',
            formik: formik,
            name: 'uploadFiles',
            titleText: 'Upload CSV document *',
            class: 'col-12',
            folder: 'temp',
            multiple: false,
            accept: '.csv',
        },
    ]

    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields.length) {
            if (props?.ignoreData) {
                let dynamicValueAssign = project_dynamicfields.filter(
                    (buscat) => {
                        return (
                            (buscat.type === 'select' ||
                                buscat.type === 'multiselect') &&
                            !props.ignoreData.includes(buscat.name) &&
                            buscat.active === 1
                        )
                    }
                )
                setFieldValue(dynamicValueAssign)
            } else {
                let dynamicValueAssign = project_dynamicfields.filter(
                    (buscat) => {
                        return (
                            (buscat.type === 'select' ||
                                buscat.type === 'multiselect') &&
                            buscat.active === 1
                        )
                    }
                )
                setFieldValue(dynamicValueAssign)
            }
        }
    }, [project_dynamicfields])

    useEffect(() => {
        if (responseStatusProduct) {
            if (responseStatusProduct.from === 'bulkProjectAction') {
                if (responseStatusProduct.status === 'success') {
                    formik.setFieldValue('uploadFiles', [])
                    formik.handleReset()
                    setIsLoading(false)
                    // toggleFullScreenPopup(false)
                    //   handleRedirectInternal(history, 'dashboard')
                } else {
                    formik.setFieldValue('uploadFiles', [])
                    formik.handleReset()
                    setIsLoading(false)
                    // toggleFullScreenPopup(false)
                }
            }
            if (responseStatusProduct.status === 'success') {
                const filterBody = {
                    filterRange: true,
                    search: 'within',
                    within: 'month',
                }
                getMainDashboardData(
                    global.customDashboardFilter
                        ? { ...global.customDashboardFilter, ...filterBody }
                        : filterBody
                )
            }
            // setIsLoading(false)
        }
    }, [responseStatusProduct])

    useEffect(() => {
        socket.on('bulkprojectupdate', (description) => {
            if (!bulkUploadPopup) {
                setBulkUploadPopup(true)
            }
            setSocketMessage(description)
        })
    }, [socket])

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue)
    }

    useEffect(() => {
        if (socketMessage) {
            if (socketMessage.status) {
                if (socketMessage.status === 'started') {
                    setActiveTab(0)
                }
                if (socketMessage.status === 'validating') {
                    setActiveTab(1)
                    const calculatedProgress =
                        (socketMessage.current / socketMessage.total) * 100
                    setProgress(calculatedProgress)
                }
                if (socketMessage.status === 'inserting') {
                    const calculatedProgress =
                        (socketMessage.current / socketMessage.total) * 100
                    setProgress(calculatedProgress)
                    setActiveTab(2)
                }
                if (socketMessage.status === 'completed') {
                    setProgress(100)
                    setActiveTab(3)
                }
            }
        }
    }, [socketMessage])

    return (
        <FullScreenPopup
            modaltitle={`ADD NEW BULK LISTING`}
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addBulkUpload">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <form
                                onSubmit={formik.handleSubmit}
                                autoComplete="nofill"
                            >
                                <div className="row">
                                    <div className="col-md-5 col-12 mb-4">
                                        <h4 className="fspTitle">
                                            Bulk Upload Instructions
                                        </h4>
                                        <ul>
                                            <li>Download the sample file.</li>
                                            <li>
                                                Don&apos;t edit the header names
                                                . Please give the appropriate
                                                values for each fields.
                                            </li>
                                            {/* <li>
                                        You have to give proper categoryTypeId.
                                        <ol>
                                            If you want to add the additional categories please
                                            mention the IDs of those in comma separated. Ex : 2,3,4
                                            .
                                        </ol>
                                    </li>
                                    <li>
                                        You have to give proper subCategoryTypeId.
                                        <ol>
                                            If you want to add the additional sub categories please
                                            mention the IDs of those in comma separated. Ex : 2,3,4
                                            .
                                        </ol>
                                    </li>
                                    <li>You have to give proper conditionTypeId.</li>
                                    <li>
                                        Below are the fields you can enable and disable them by
                                        giving 0 or 1 , that means it should have 0 or 1
                                        <ol>auction, buynow.</ol>
                                    </li> */}
                                            <li>
                                                Below are the fields required.
                                                <ol>
                                                    {!props?.norprice ? (
                                                        <li>
                                                            sprice - must be
                                                            less than rprice
                                                        </li>
                                                    ) : (
                                                        <li>sprice</li>
                                                    )}
                                                    {!props?.norprice ? (
                                                        <li>
                                                            rprice - must be
                                                            greater sprice and
                                                            less than bprice
                                                        </li>
                                                    ) : null}
                                                    {!props?.nobprice ? (
                                                        <li>
                                                            bprice - must be
                                                            greater or equal
                                                            rprice
                                                        </li>
                                                    ) : null}
                                                    {props?.requiredFields
                                                        ? props.requiredFields.map(
                                                              (data) => (
                                                                  <li>
                                                                      {data}
                                                                  </li>
                                                              )
                                                          )
                                                        : null}
                                                </ol>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-md-7 col-12">
                                        <div className="row">
                                            <div className="col-12">
                                                <h4 className="fspTitle">
                                                    Upload CSV document
                                                </h4>
                                            </div>
                                            {Object.values(
                                                mapData(productListing)
                                            )}
                                        </div>
                                        {fieldValue?.length ? (
                                            <div className="row">
                                                <div className="col-12">
                                                    <h5 className="fspSubTitle">
                                                        Review
                                                    </h5>
                                                    <table className="table text-left">
                                                        <DynamicDropdown
                                                            arrayValue={
                                                                fieldValue
                                                            }
                                                            showWithId={
                                                                props.showWithId
                                                            }
                                                        />
                                                    </table>
                                                </div>
                                            </div>
                                        ) : null}

                                        <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                            <SecondaryButton
                                                type="button"
                                                onClick={() =>
                                                    getAllSampleDownload({
                                                        action: 'sample',
                                                        page: `projects`,
                                                        report_name:
                                                            'LISTING SAMPLE',
                                                        ignoreFields:
                                                            props.ignoreFields,
                                                        additionalFields:
                                                            props.additionalFields,
                                                    })
                                                }
                                                label="Download Sample"
                                            />
                                            <PrimaryButton
                                                onClick={() => {
                                                    formSubmit('draft')
                                                }}
                                                type="button"
                                                label="Submit"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </>
                    )}
                </div>

                <CustomDialog
                    title={'Bulk Upload Status'}
                    open={bulkUploadPopup}
                    className="bulkUploadStatusModal"
                    function={changeSetBulkUploadPopup}
                    closeBtn={() => changeSetBulkUploadPopup()}
                >
                    {/* <h5>Bulk Upload Status</h5> */}
                    {/* {socketMessage} */}
                    <div>
                        {socketMessage?.status === 'error' ? (
                            <> {socketMessage?.message} </>
                        ) : (
                            <div className="uploadStatusTracker">
                                <Stepper
                                    activeStep={activeTab}
                                    alternativeLabel
                                >
                                    <Step>
                                        <StepLabel>Started</StepLabel>
                                    </Step>
                                    <Step>
                                        <StepLabel>Validating</StepLabel>
                                    </Step>
                                    <Step>
                                        <StepLabel>Inserting</StepLabel>
                                    </Step>
                                    <Step>
                                        <StepLabel>Completed</StepLabel>
                                    </Step>
                                </Stepper>

                                <LinearProgress
                                    variant="determinate"
                                    value={progress}
                                />
                                {socketMessage?.status === 'completed' ? (
                                    <p className="statusStepCount">
                                        <span>Total Records:</span>{' '}
                                        {socketMessage?.total || 0}{' '}
                                    </p>
                                ) : (
                                    <p className="statusStepCount">
                                        {' '}
                                        {socketMessage?.current || 0} /{' '}
                                        {socketMessage?.total || 0}{' '}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                </CustomDialog>
            </div>
        </FullScreenPopup>
    )
}

export default BulkListing
